// extracted by mini-css-extract-plugin
module.exports = {"btn":"button-module--btn--3teJJ","primary":"button-module--primary--14-Wb","secondary":"button-module--secondary--gSHsc"};